// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see ThemePickerManageViewEvent
 */
export var ThemePickerManageView = function (_a) {
    var source = _a.source;
    return ({
        name: "ThemePicker Manage View",
        parameters: {
            cdf_entity: "ThemePicker",
            cdf_action: "Manage",
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ThemePickerManageSelectEvent
 */
export var ThemePickerManageSelect = function (_a) {
    var theme = _a.theme, index = _a.index;
    return ({
        name: "ThemePicker Manage Select",
        parameters: {
            cdf_entity: "ThemePicker",
            cdf_action: "Manage",
            theme: theme !== undefined && theme !== null ? theme.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            index: index !== undefined && index !== null ? index.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ThemePickerManageConfirmEvent
 */
export var ThemePickerManageConfirm = function (_a) {
    var theme = _a.theme, index = _a.index;
    return ({
        name: "ThemePicker Manage Confirm",
        parameters: {
            cdf_entity: "ThemePicker",
            cdf_action: "Manage",
            theme: theme !== undefined && theme !== null ? theme.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            index: index !== undefined && index !== null ? index.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ThemePickerManageExitEvent
 */
export var ThemePickerManageExit = function () { return ({
    name: "ThemePicker Manage Exit",
    parameters: {
        cdf_entity: "ThemePicker",
        cdf_action: "Manage",
    }
}); };
